(() => {
  const ROOT_SELECTOR = "[data-veloconnect-delivery]";
  const ALLOWED_STATES = new Set(["available", "expected", "announced"]);

  const parseData = (root) => {
    const source = root.querySelector("[data-veloconnect-delivery-data]");

    try {
      return JSON.parse(source?.textContent || "{}");
    } catch {
      return {};
    }
  };

  // Actual location.available evidence from the authenticated backend, embedded
  // in Liquid. Pickup availability may include supplier transfers and is not stock.
  const readLocalStock = (sourceDocument) => {
    try {
      return JSON.parse(sourceDocument?.querySelector("[data-tm-local-stock]")?.textContent || "{}");
    } catch {
      return {};
    }
  };
  const localStock = readLocalStock(document);
  const isLocalInStock = (evidence) => {
    const now = Math.floor(Date.now() / 1000);
    return evidence?.version === 1 &&
      evidence.locationId === "gid://shopify/Location/96163955020" &&
      evidence.tracked === true && Number.isSafeInteger(evidence.available) &&
      evidence.available > 0 && Number.isSafeInteger(evidence.checkedAt) &&
      evidence.checkedAt <= now && now - evidence.checkedAt < 7200;
  };

  const readVariantId = (root) => {
    const section = root.closest('[id^="shopify-section-"]');
    const selected = section?.querySelector(
      'variant-picker input[data-variant-id]:checked, variant-picker option[data-variant-id]:checked',
    );
    const formInput = section?.querySelector(
      'product-form [name="id"], form[data-type="add-to-cart-form"] [name="id"], form [name="id"]',
    );
    const urlVariant = new URL(window.location.href).searchParams.get("variant");

    return (
      selected?.dataset.variantId ||
      (formInput instanceof HTMLInputElement ? formInput.value : "") ||
      urlVariant ||
      root.dataset.selectedVariantId ||
      ""
    );
  };

  const render = (root, variantId) => {
    const variants = parseData(root);
    const variant = variants[String(variantId)];
    const savedStatus = variant?.status;
    const modelYear = Number(root.dataset.modelYear || 0);
    const currentYear = new Date().getFullYear();
    const label = root.querySelector("[data-veloconnect-delivery-label]");

    let state = "";
    let text = "";

    if (variant?.available === true && isLocalInStock(localStock[String(variantId)])) {
      state = "available";
      text = "Auf Lager";
    } else if (
      savedStatus &&
      ALLOWED_STATES.has(savedStatus.state) &&
      typeof savedStatus.label === "string" &&
      savedStatus.label.trim()
    ) {
      state = savedStatus.state;
      text = savedStatus.state === "available" ? "Verfügbar" : savedStatus.label.trim();
    } else if (variant && variant.available === false && modelYear > currentYear) {
      state = "announced";
      text = `Neuheit ${modelYear} – Liefertermin noch nicht bekannt`;
    }

    root.classList.remove(
      "veloconnect-delivery--available",
      "veloconnect-delivery--expected",
      "veloconnect-delivery--announced",
    );

    if (!state || !text) {
      root.hidden = true;
      return;
    }

    if (label) label.textContent = text;
    root.classList.add(`veloconnect-delivery--${state}`);
    root.dataset.selectedVariantId = String(variantId);
    root.hidden = false;
  };

  const initialize = (root) => {
    if (root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";

    const sync = (forcedVariantId) => {
      const variantId = forcedVariantId || readVariantId(root);
      if (variantId) render(root, variantId);
    };

    sync();

    const section = root.closest('[id^="shopify-section-"]');
    section?.addEventListener("change", (event) => {
      const target = event.target;
      const variantId = target instanceof HTMLElement ? target.dataset.variantId : undefined;
      window.requestAnimationFrame(() => sync(variantId));
    });

    ["variant:update", "variant:change", "product:variant-change", "shopify:variant-change"].forEach(
      (eventName) => {
        document.addEventListener(eventName, (event) => {
          const detail = event.detail || {};
          const variantId = detail.resource?.id || detail.variant?.id || detail.variantId;
          // Ignore events for other products and obsolete variant responses.
          if (variantId && String(variantId) !== String(readVariantId(root))) return;
          Object.assign(localStock, readLocalStock(detail.data?.html));
          sync(variantId ? String(variantId) : undefined);
        });
      },
    );

    window.addEventListener("popstate", () => sync());
  };

  const initializeAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initialize);
  };

  initializeAll();
  document.addEventListener("shopify:section:load", initializeAll);
})();

